export { default } from './Gif'
